import {BaseGenericItemsStore, GenericItemsForm, GenericItemsUtils, IGetAllParams, Groups} from "@leap4/frontend";
import type {GridColDef, GridRenderCellParams} from "@leap4/frontend";
import {UsersBaseUrl} from "../../../config/generals";
import {urlService} from "../../routing/urlsService";
import {Link} from "react-router-dom";
import {RootState} from "../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";

const fields = {
    Name: 1,
    email: 1,
}

const getParams: IGetAllParams = {
    fields
}
let columns: GridColDef[];
let store: BaseGenericItemsStore<{ _id: string, isActive: boolean }>

function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: `${UsersBaseUrl}`
    }, fields, {
        created: {},
        isActive: {},
        updated: {},
        name: {editLinkFunc: (id: string) => urlService.editUsers(id)}
    })
    store = storeAndColumns.store;
    columns = storeAndColumns.columns;
    const nameCol = columns.find(x => (x.field === "Name"));
    //const emailCol = columns.find(x => (x.field === "email"));
    nameCol.renderCell = (params: GridRenderCellParams) => {
        return <Link to={urlService.editUsers(params.id.toString())}><strong>{params.row.name}</strong></Link>
    };
}

const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const PublisherLoginsDashboardModule = (props:PropsFromRedux) => {
    setStoreAndColumns();

    return (
        <GenericItemsForm
            organization={props.selectedOrganization}
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.users(),
                text: "Users Dashboard",
                icon: <Groups />
            }}
            createButton={{to: "user/add", text: "Create User"}}
            tableProps={{pageSize: 100, style: {minHeight: "75vh"}}}
            getAllParams={getParams}

        />
    );
};

export default connector(PublisherLoginsDashboardModule)